import React from 'react';
import PropTypes from 'prop-types';
import HtmlHead from '../../components/01_atoms/HtmlHead';
import Paragraphs from '../../components/02_molecules/Paragraphs';

import '../../styles/gifts/sass/theme.scss';

const GiftsCategoryPage = ({ entity: category }) => {
  // Get all blocks from the page.
  let blocks = [];

  // Add blocks that configured for the category.
  if (category.blocks && category.blocks.length) {
    blocks = blocks.concat(category.blocks);
  }
  blocks.push({ blockType: 'gifts_catalog' });
  if (category.blocksBottom && category.blocksBottom.length) {
    blocks = blocks.concat(category.blocksBottom);
  }

  return (
    <div>
      <HtmlHead metatags={category.metaTags} pageTitle={category.title} />
      <Paragraphs blocks={blocks} layout={'centered'} />
    </div>
  );
};

GiftsCategoryPage.propTypes = {
  entity: PropTypes.object.isRequired,
};

export default GiftsCategoryPage;
